export default __webpack_public_path__ + "static/media/mvp-banner.c2f90b71.png";